import NProgress from 'nprogress';
import { Switch, Route } from 'react-router-dom';
import { Suspense, Fragment, lazy, useEffect, useMemo } from 'react';
// material
import { makeStyles } from '@material-ui/core/styles';
// guards
import GuestGuard from '../guards/GuestGuard';
// components
import LoadingScreen from '../components/LoadingScreen';

// import the brand context provider

//
import { PATH_AUTH } from './paths';
import DashboardRoutes from './dashboard.routes';
import AuthGuard from "../guards/AuthGuard";


// ----------------------------------------------------------------------

const nprogressStyle = makeStyles((theme) => ({
  '@global': {
    '#nprogress': {
      pointerEvents: 'none',
      '& .bar': {
        top: 0,
        left: 0,
        height: 2,
        width: '100%',
        position: 'fixed',
        zIndex: theme.zIndex.snackbar,
        backgroundColor: theme.palette.primary.main,
        boxShadow: `0 0 2px ${theme.palette.primary.main}`
      },
      '& .peg': {
        right: 0,
        opacity: 1,
        width: 100,
        height: '100%',
        display: 'block',
        position: 'absolute',
        transform: 'rotate(3deg) translate(0px, -4px)',
        boxShadow: `0 0 10px ${theme.palette.primary.main}, 0 0 5px ${theme.palette.primary.main}`
      }
    }
  }
}));

function RouteProgress(props) {
  nprogressStyle();

  NProgress.configure({
    speed: 500,
    showSpinner: false
  });

  useMemo(() => {
    NProgress.start();
  }, []);

  useEffect(() => {
    NProgress.done();
  }, []);

  return <Route {...props} />;
}

export function renderRoutes(routes = []) {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Component = route.component;
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          // console.log(route);
          return (
            <RouteProgress
              key={i}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>

                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Component {...props} />
                    )}

                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  );
}


const routes = [
  // Others Routes
  {
    exact: true,
    guard: GuestGuard,
    path: PATH_AUTH.login,
    component: lazy(() => import('../views/authentication/Login'))
  },
  {
    exact: true,
    path: '/',
    component: lazy(() => import('../views/Capture'))
  },
  {
    exact: true,
    path: '/msp',
    component: lazy(() => import('../msp/Capture'))
  },
  {
    exact: true,
    path: '/firefly',
    component: lazy(() => import('../views/CaptureFireflyDirect'))
  },
  {
    exact: true,
    path: '/fireflyloop',
    component: lazy(() => import('../views/CaptureFirefly'))
  },
  {
    exact: true,
    path: '/newpass',
    component: lazy(() => import('../views/NewPass'))
  },
  {
    exact: true,
    path: '/confirmbooking',
    component: lazy(() => import('../components/igtm/ConfirmBooking/ConfirmBooking'))
  },
  {
    exact: true,
    path: '/taxifareacceptance',
    component: lazy(() => import('../components/igtm/TaxiFareAcceptance/FareAcceptance'))
  },
  {
    exact: true,
    path: '/fulfillmentconfirmation',
    component: lazy(() => import('../components/igtm/fulfillmentInput/ConfirmBooking'))
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('../views/Page404'))
  },
  {
    exact: true,
    path: '/track/:taxiHash',
    component: lazy(() => import('../components/igtm/TaxiTracking/TrackTaxi')),
    mainNav:false
  },
  {
    exact: true,
    guard: AuthGuard,
    path: '/ttrack/:taxiId',
    component: lazy(() => import('../components/igtm/TaxiTracking/TrackTaxiById')),
    mainNav:false
  },

  // App Routes
  DashboardRoutes,

  // Home Routes
  // HomeRoutes
];

export default routes;
